module.exports = __webpack_public_path__ + "static/img/中国创翼一等奖.464e0571.jpg";